import { useState } from "react";
import { Mic, Plus } from "lucide-react";
import RecordingFlowController from "./RecordingFlowController";
import { useAuth } from "../../lib/auth-context";

const STROKE = 1.5;

const useIsHm = () => {
  const { member } = useAuth();
  return member?.role === "hiring_manager";
};

/** Persistent emerald sidebar CTA — primary entry into recording. */
export function SidebarStartButton() {
  const [open, setOpen] = useState(false);
  const isHm = useIsHm();
  if (isHm) return null;
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex w-full items-center justify-center gap-2 rounded-md bg-emerald-800 px-3 py-2.5 text-[14px] font-medium text-white shadow-xs transition hover:bg-emerald-900 active:bg-emerald-950"
        data-testid="sidebar-start-interview"
      >
        <Mic className="h-4 w-4" strokeWidth={STROKE} />
        Start interview
      </button>
      <RecordingFlowController open={open} onOpenChange={setOpen} />
    </>
  );
}

/** Hero CTA used on the empty Dashboard. */
export function DashboardHeroStart() {
  const [open, setOpen] = useState(false);
  const isHm = useIsHm();
  if (isHm) return null;
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-md bg-emerald-800 px-5 py-3 text-[15px] font-medium text-white shadow-xs transition hover:bg-emerald-900 active:bg-emerald-950"
        data-testid="dashboard-start-interview"
      >
        <Mic className="h-4 w-4" strokeWidth={STROKE} />
        Record your first interview
      </button>
      <RecordingFlowController open={open} onOpenChange={setOpen} />
    </>
  );
}

/** "New Interview" button used on /interviews page top-right. */
export function InterviewsNewButton() {
  const [open, setOpen] = useState(false);
  const isHm = useIsHm();
  if (isHm) return null;
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="hp-btn-primary"
        data-testid="interviews-new"
      >
        <Plus className="h-4 w-4" strokeWidth={STROKE} />
        New interview
      </button>
      <RecordingFlowController open={open} onOpenChange={setOpen} />
    </>
  );
}

/** Mobile-only floating action button, bottom-right. */
export function MobileFab() {
  const [open, setOpen] = useState(false);
  const isHm = useIsHm();
  if (isHm) return null;
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-emerald-800 text-white shadow-md transition hover:bg-emerald-900 active:bg-emerald-950 lg:hidden"
        aria-label="Start interview"
        data-testid="mobile-fab"
      >
        <Mic className="h-6 w-6" strokeWidth={STROKE} />
      </button>
      <RecordingFlowController open={open} onOpenChange={setOpen} />
    </>
  );
}
